module.exports = __webpack_public_path__ + "static/media/mtgHome.b4eecb4a.jpg";